<script setup>
import { onMounted, ref } from 'vue';
import ChatSidebar from './components/ChatSidebar.vue';
import ChatContainer from './components/ChatContainer.vue';
import { useChatStore } from './stores/chat.js';
import { systemApi } from './services/api.js';
import { WifiOff } from 'lucide-vue-next';

const chatStore = useChatStore();
const isConnected = ref(true);
const connectionError = ref(null);

onMounted(async () => {
  try {
    await systemApi.healthCheck();
    isConnected.value = true;
    connectionError.value = null;
  } catch (err) {
    isConnected.value = false;
    connectionError.value =
      'Unable to connect to the backend. Please ensure the API server is running.';
    console.error('Backend connection failed:', err);
  }
});
</script>

<template>
  <ciena-layout>
    <div style="position: relative">
      <div class="flex h-full w-full overflow-hidden bg-main-bg" style="height: 100vh">
        <!-- Sidebar -->
        <ChatSidebar />

        <!-- Main content area -->
        <main class="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
          <!-- Connection status banner -->
          <div
            v-if="!isConnected"
            class="flex items-center gap-3 px-6 py-3 bg-red-500/10 border-b border-red-500/20 shrink-0"
          >
            <WifiOff :size="16" class="text-red-400 shrink-0" />
            <span class="text-sm text-red-400">{{ connectionError }}</span>
          </div>

          <!-- Chat container takes remaining space -->
          <ChatContainer class="flex-1 min-h-0" />
        </main>
      </div>
    </div>
  </ciena-layout>
</template>
<style lang="scss" scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
@import './main.css';
</style>
